/**
 * Created by Ning Jiang on 10/24/2018.
 */

import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {ReelSymbolStateCreator} from "@nolimitcity/slot-game/bin/core/reelsymbol/ReelSymbolStateCreator";
import {ISymbolStateConfig, StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {TombOfAkhenatenGameConfig} from "../TombOfAkhenatenGameConfig";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {WildPart} from "../enums/WildPart";

export class TombOfAkhenatenReelSymbolStateCreator extends ReelSymbolStateCreator {

    constructor() {
        super();
    }

    protected winStateCreator(symbol: StateReelSymbol, stateKey: string, stateConfig: ISymbolStateConfig): TimelineSprite | null {
        const stateAnimation: TimelineSprite | null = this.getBasicStateAnimation(symbol, stateKey, stateConfig);
        if (stateAnimation) {
            (<PIXI.Sprite[]>symbol.children).forEach((sprite: PIXI.Sprite) => {
                if (sprite.name && sprite.visible) {
                    (sprite as PIXI.Sprite).tint = 0xffffff;
                }
            });
        }
        return stateAnimation;
    }

    protected getBasicStateAnimation(symbol: StateReelSymbol, stateKey: string, stateConfig: ISymbolStateConfig): TimelineSprite | null {
        const symName: string = symbol.symName,
            spineStates: string[] = ["win", "Idle"];
        let resourceName: string = "";
        if (symName == "W" && stateKey === TombOfAkhenatenGameConfig.instance.SYMBOL_STATES.idle?.keyword) {
            const spine: PIXI.spine.Spine = new PIXI.spine.Spine(GameResources.getSpineAsset("wild_idle"));
            spine.name = "wildIdle";
            spine.y = 5;
            return (spine as any);
        }

        if (symName == "W" && (stateKey === TombOfAkhenatenGameConfig.instance.SYMBOL_STATES.win.keyword)) {
            const container: PIXI.Container = new PIXI.Container();
            container.name = "WILD_WIN_ANIM_CONTAINER";
            const bottomCutPartSpine: PIXI.spine.Spine = new PIXI.spine.Spine(GameResources.getSpineAsset(WildPart.BOTTOM_CUT));
            const mask: PIXI.Graphics = this.createWildMask(symbol.reelId);
            const bottom_partSpine: PIXI.spine.Spine = new PIXI.spine.Spine(GameResources.getSpineAsset(WildPart.BOTTOM));
            const wild_top_partSpine: PIXI.spine.Spine = new PIXI.spine.Spine(GameResources.getSpineAsset(WildPart.TOP));
            const wild_text: PIXI.spine.Spine = new PIXI.spine.Spine(GameResources.getSpineAsset(WildPart.TEXT));

            bottomCutPartSpine.name = WildPart.BOTTOM_CUT;
            bottom_partSpine.name = WildPart.BOTTOM;
            wild_top_partSpine.name = WildPart.TOP;
            wild_text.name = WildPart.TEXT;
            container.addChild(mask, bottom_partSpine, wild_top_partSpine, wild_text, bottomCutPartSpine);
            bottom_partSpine.mask = mask;
            wild_top_partSpine.mask = mask;
            bottomCutPartSpine.y = 5;
            wild_text.y = 13;
            wild_top_partSpine.y = 8;
            bottom_partSpine.y = 8;
            return (container as any);
        }

        if (symName == "W2" && (stateKey === TombOfAkhenatenGameConfig.instance.SYMBOL_STATES.win.keyword)) {
                const spineTextures: PIXI.spine.core.SkeletonData = GameResources.getSpineAsset("Wild_toggle"),
                spine: PIXI.spine.Spine = new PIXI.spine.Spine(spineTextures);
            return (spine as any);
        }

        if (spineStates.indexOf(stateKey) != -1) {
            if (TombOfAkhenatenGameConfig.instance.SYMBOLS_WITH_WIN_SPINE.indexOf(symName) != -1) {
                resourceName = symName.toLowerCase();
                const spineTextures: PIXI.spine.core.SkeletonData = GameResources.getSpineAsset(resourceName),
                    spine: PIXI.spine.Spine = new PIXI.spine.Spine(spineTextures);
                return (spine as any);
            } else if (TombOfAkhenatenGameConfig.instance.LOW_SYMBOLS_WITH_SPINE.indexOf(symName) != -1) {
                resourceName = "lowSym"
                const spineTextures: PIXI.spine.core.SkeletonData = GameResources.getSpineAsset(resourceName),
                    spine: PIXI.spine.Spine = new PIXI.spine.Spine(spineTextures);
                spine.skeleton.setSkin(null);
                spine.skeleton.setSkinByName(TombOfAkhenatenGameConfig.instance.LOW_SYM_MAP.get(symName) || "");
                spine.skeleton.setSlotsToSetupPose();
                //spine.y = 5;
                if (stateKey === "win") {
                    spine.y = -2;
                }
                return (spine as any);
            }
            // if (resourceName) {
            //     const spineTextures: PIXI.spine.core.SkeletonData = GameResources.getSpineAsset(resourceName),
            //         spine: PIXI.spine.Spine = new PIXI.spine.Spine(spineTextures);
            //     return (spine as any);
            // }
        }
        return super.getBasicStateAnimation(symbol, stateKey, stateConfig);
    }

    private createWildMask(reelId: number) {
        const symSpineMask: PIXI.Graphics = new PIXI.Graphics(),
            maskX: number = (0 - (TombOfAkhenatenGameConfig.instance.SYMBOL_WIDTH / 2) - 50),
            maskY: number = (0 - (TombOfAkhenatenGameConfig.instance.SYMBOL_HEIGHT_FOR_OVERLAPPING_SYMBOLS / 2) - 50),
            maskW: number = (TombOfAkhenatenGameConfig.instance.SYMBOL_WIDTH + 100),
            maskH: number = (TombOfAkhenatenGameConfig.instance.SYMBOL_HEIGHT_FOR_OVERLAPPING_SYMBOLS + 100);

        symSpineMask.beginFill(0xFFFF0B, 0.5);
        symSpineMask.drawRect(maskX, maskY, maskW, maskH);
        symSpineMask.endFill();
        symSpineMask.name = "symSpineMask_" + reelId;
        return symSpineMask;
    }
}